import React from "react";

const VideoSection = ({ data }) => {
    return (
        <div className="w-full mx-auto max-w-[80%] lg:max-w-7xl xs:max-w-[90%] 2xl:max-w-6xl pt-24 pb-10">
            <div className="relative grid grid-cols-[30%_70%] lg:grid-cols-1 xs:grid-cols-1">
                <div className="flex flex-col justify-start pt-4 max-w-md xs:px-4 items-start gap-y-1 lg:pl-12 xs:pl-0 xs:w-full">
                    {data.title && (
                        <h1 className="text-6xl leading-tight pb-4 xs:text-3xl xs:leading-snug 2xl:text-4xl text-[#EC0000]">
                            {data.title}
                        </h1>
                    )}
                    {data.subheading && (
                        <p className="text-xl pt-1 2xl:text-lg xs:text-base text-[#767676]">{data.subheading}</p>
                    )}
                    <div className="flex items-center gap-3 pt-8 xs:pt-4">
                        {data.button && (
                            <button className="text-xl bg-white py-2 px-4 rounded text-[#EC0000] xs:text-base">
                                {data.button}
                            </button>
                        )}
                        {data.buttonLogo && <img src={data.buttonLogo} alt="Button Logo" className="h-10 xs:h-8" />}
                    </div>
                </div>

                <div className="flex h-full pl-32 xs:pl-0 xs:px-0 gap-3 items-start 2xl:px-4 xs:w-full">
                    {data.video && (
                        <div className="w-full xs:px-2">
                            <iframe
                                className="w-full h-[500px] md:h-[400px] lg:h-[600px] xs:h-[250px] min-h-[250px] rounded-lg"
                                src={`https://www.youtube.com/embed/${getYouTubeID(data.video)}`}
                                title="YouTube video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const getYouTubeID = (url) => {
    const regExp =
        /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : null;
};

export default VideoSection;
